import {
  Box,
  Button,
  chakra,
  Flex,
  FormControl,
  FormErrorMessage,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import { isValidPassword } from '@common/utility/validations';
import { faEye, faEyeSlash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSignUpModel } from '../../models/SignUpModel';
import { PageHeader } from './PageHeader';

type FormValues = { password: string };

export const PasswordForm: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const { password, setPassword } = useSignUpModel();
  const Icon = chakra(FontAwesomeIcon);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = handleSubmit(async (data) => {
    setIsLoading(true);
    setPassword(data.password);
    setIsLoading(false);
  });

  return (
    <Flex direction={'column'} gap={10} align="center">
      {/* Header */}
      <PageHeader
        title="Create a password for your login"
        subtitle="You'll use this to login to your account."
        step={2}
        steps={4}
      />

      {/* Form */}
      <Box as="form" onSubmit={onSubmit} minW={['100%', '350px']}>
        <FormControl
          as={Flex}
          alignItems={'center'}
          flexDir={'column'}
          isInvalid={Boolean(errors.password)}
          mb={5}
          justifyContent={'center'}>
          <InputGroup size="md" maxW={['full', 350]}>
            <Input
              id="password"
              mb={3}
              placeholder="Create a password"
              type={show ? 'text' : 'password'}
              {...register('password', {
                minLength: { message: 'Password must be at least 8 characters', value: 8 },
                required: 'Password is required',
                validate: (v) =>
                  isValidPassword(v) ||
                  'Password must be at least 8 characters, contain a number, and a special character',
              })}
              defaultValue={password}
              autoFocus={true}
            />
            <InputRightElement mx="1.5">
              <IconButton
                aria-label="Show hide password"
                bg="transparent"
                _hover={{ bg: 'transparent' }}
                _active={{ bg: 'transparent' }}
                color="grey"
                onClick={() => setShow(!show)}
                icon={<Icon icon={show ? faEye : faEyeSlash} />}
              />
            </InputRightElement>
          </InputGroup>
          <FormErrorMessage>{errors.password && errors.password.message}</FormErrorMessage>
        </FormControl>
        <Button
          isDisabled={Boolean(errors.password) || isLoading}
          isLoading={isLoading}
          type="submit"
          w="full"
          p={7}
          maxW={'full'}>
          Continue
        </Button>
      </Box>
    </Flex>
  );
};
